import { InputText, Radio } from '@/components';
import { FormInputFilterEvent } from '@/features/cancelTickets/types';
import { FormData, FormErrors, OnChangeFormInput } from '@/hooks/useForm';
import React from 'react';
import { Form } from 'reactstrap';

interface FilterContentProps {
  formData: FormData;
  formErrors: FormErrors;
  onChangeFormInput: OnChangeFormInput;
}

export const FilterContentEvent: React.FC<FilterContentProps> = ({
  formData,
  formErrors,
  onChangeFormInput,
}) => {
  const optionFilter = [{ label: 'Nome', value: 'name' }];

  return (
    <div className="filter-modal-content">
      <Form noValidate={true} onSubmit={(e): void => e.preventDefault()}>
        <span className="filter-name">Filtrar por:</span>
        <Radio
          options={optionFilter}
          name="filterSearch"
          style={{ fontSize: '21px' }}
          value={formData[FormInputFilterEvent.filterSearch]}
          onChange={e => onChangeFormInput(FormInputFilterEvent.filterSearch)(e.target.value)}
          error={formErrors.filterSearch && formErrors.filterSearch[0]}
        />

        <InputText
          name="inputSearch"
          label={
            optionFilter.find(
              values => formData[FormInputFilterEvent.filterSearch] === values.value,
            )?.label ?? ''
          }
          placeholder={
            formData[FormInputFilterEvent.filterSearch] === 'protocol' ? 'Digite o protocolo' : ''
          }
          maxLength={18}
          value={formData[FormInputFilterEvent.inputSearch]}
          onChange={e => onChangeFormInput(FormInputFilterEvent.inputSearch)(e.target.value)}
          error={formErrors.inputSearch && formErrors.inputSearch[0]}
        />
      </Form>
    </div>
  );
};
